<template>
  <v-container>
    <v-dialog v-model="hasAccepted18Plus" persistent max-width="350" overlay-opacity="1">

      <v-card>
        <v-card-title class="headline">There's some adult shit here</v-card-title>
        <v-card-text>Repost Sleuth doesn't currently keep track of NSFW posts.  This means we can't currently filter them out.  By clicking Agree you are saying you're over 18 and don't mind seeing some weird shit</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text to="/">Disagree</v-btn>
          <v-btn color="green darken-1" text @click="over18Agree">Agree</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
export default {
  name: "Over18Diag",
  methods: {
    over18Agree() {
      this.$store.commit('acceptOver18', true)
    }
  },
  computed: {
    hasAccepted18Plus: function () {
      return !this.$store.getters.over18;
    }
  }
}
</script>

<style scoped>

</style>